<template>
<div class="chapter">
<div class="inner_page">
<p class="P_RaggedRight" id="auto_bookmark_toc_1"><span style=" font-weight: bold; font-size: 1.17em;">Jackson’s wolf was going crazy at the thought of Harris wearing his things. Sweat trickled down his back, and his body felt tender and hot, like the shift was prickling at his skin.</span> It had never been like this with Raoul or his other boyfriends. He had no idea what was going on or why it was directed at one of his best friends. A mix of anxiety and homesickness, perhaps, and all of it focused on Harris because he was always such a comforting, solid presence.</p>
<p class="P_RaggedRight"> </p>
<p class="P_RaggedRight">Jackson snorted. That was all bullshit. He had a good old-fashioned crush, and he couldn’t explain it away as his worry over the new job.</p>
<p class="P_RaggedRight"> </p>
<p class="P_RaggedRight">No, this was carnal lust mixed with affection. Dammit.</p>
<p class="P_RaggedRight"> </p>
<p class="P_RaggedRight">It was ridiculous. They’d been friends for over a decade. He wouldn’t throw away their friendship for a fuck. Harris was worth more than that.</p>
<p class="P_RaggedRight"> </p>
<p class="P_RaggedRight">God, he was such a dick.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0002.vue?1054febc